<template>
  <v-card class="my-4 dias-mais-frequentes">
    <v-card-title>
      <span class="pa-1 table-card-title">Dia mais frequente de compra</span>
    </v-card-title>
    <div class="data-box">
      <mf-loading loader="semana-compras" loader-type="dynamic" :dynamicAmount="8" :dynamicWidth="200">
        <v-data-table :headers="headers" :items="dataFormatada" hide-default-footer disable-pagination>
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-left">{{ item['NOME_DIA_SEMANA'] }}</td>
              <td class="text-right">{{ item['NUM_TOTAL_CUPONS'] | abreviation({ isInteger: true }) }}</td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </div>
  </v-card>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    items: Array,
  },
  computed: {
    dataFormatada() {
      return cloneDeep(this.items).map((obj) => {
        switch (obj['NUM_DIA_SEMANA']) {
          case 0:
            obj['NOME_DIA_SEMANA'] = 'Domingo'
            break
          case 1:
            obj['NOME_DIA_SEMANA'] = 'Segunda-feira'
            break
          case 2:
            obj['NOME_DIA_SEMANA'] = 'Terça-feira'
            break
          case 3:
            obj['NOME_DIA_SEMANA'] = 'Quarta-feira'
            break
          case 4:
            obj['NOME_DIA_SEMANA'] = 'Quinta-feira'
            break
          case 5:
            obj['NOME_DIA_SEMANA'] = 'Sexta-feira'
            break
          case 6:
            obj['NOME_DIA_SEMANA'] = 'Sábado'
            break
        }
        return obj
      })
    },
    headers() {
      return [
        {
          text: 'Dia',
          value: 'NUM_DIA_SEMANA',
          align: 'left',
        },
        {
          text: 'Cupons',
          value: 'NUM_TOTAL_CUPONS',
          align: 'right',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.dias-mais-frequentes {
  height: 330px !important;
  overflow: hidden;
  .data-box {
    overflow-y: scroll;
    height: 80%;
  }
}
</style>
